<template>
    <v-container fluid class="py-0">
        <v-container class="px-0">
            <v-row>
                <v-radio-group v-model="cookieChoiceRadio">
                    <template v-slot:label>
                        <div>{{ privacyData.pageChoiceHeading }}</div>
                    </template>
                    <v-radio value="1">
                        <template v-slot:label>
                            <div>{{ privacyData.pagePersonalPackageTitle }}</div>
                        </template>
                    </v-radio>
                    <div class="pa12 .theme--light">
                        <VuetifyRender :html="privacyData.pagePersonalCookieText"></VuetifyRender>
                    </div>
                    <v-radio value="0">
                        <template v-slot:label>
                            <div>{{ privacyData.pageStandardPackageTitle }}</div>
                        </template>
                    </v-radio>
                    <div class="pa12 theme--light">
                        <VuetifyRender :html="privacyData.pageStandardCookieText"></VuetifyRender>
                    </div>
                </v-radio-group>
            </v-row>
            <v-row>
                <VuetifyRender :html="pageItem.MainText"></VuetifyRender>
            </v-row>
        </v-container>
    </v-container>
</template>
<style scoped>


.v-selection-control__wrapper{
  display: block !important;
}
</style>
<script setup>
const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },

});
    const dataAll = useDataAll();
    const { $analytics } = useNuxtApp()
    // const privacyData = dataAll.getKey("privacyData", []);
    const cookie_policy_accepted = useCookie("cookie_policy_accepted", {
        maxAge: 24 * 60 * 60 * 365,
    });
    const privacyData = {
        pagePersonalPackageTitle :  dataAll.getStatic("privacy_widget_personal_title", "Personal cookie package"),
        pageStandardPackageTitle :  dataAll.getStatic("privacy_widget_standard_title", "Standard cookie package"),
        pageText:                   dataAll.getStatic("privacy_widget_intro_text", "Choice your preferences"),
        pageStandardCookieText:     dataAll.getStatic("privacy_widget_standard_text", "contact us:"),
        pagePersonalCookieText:     dataAll.getStatic("privacy_widget_personal_text", "contact us:"),
        pageChoiceHeading:          dataAll.getStatic("privacy_widget_title", "Privacy preferences")
    };


    let cookieChoiceRadio = ref(cookie_policy_accepted.value == 1 ? "1" : "0");

    watch(cookieChoiceRadio, (newValue) => {
        cookie_policy_accepted.value = newValue == true ? 1 : 0;
        if (newValue ==1  ){
            $analytics.allConsentGranted()
        } else {
            $analytics.allConsentRevoked()
        };
    });

</script>